import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IReferal } from "../../components/ReferalCard/ReferalCard";
import { IReferalRewardMilestone, IReferalsState } from ".";
import { api } from "../../api/api";

interface IGetReferalsResponse {
    referals: IReferal[];
    milestones: IReferalRewardMilestone[];
};

export const getReferals = createAsyncThunk<IGetReferalsResponse>(
    'referals/getReferals',
    async () => {
        const data = await api.referals.getReferals();
        return data;
    }
);

const getReferalsHandler = (builder: ActionReducerMapBuilder<IReferalsState>) => {
    builder
        .addCase(getReferals.pending, (state) => {
            state.loading = true;
            state.error = '';
        })
        .addCase(getReferals.fulfilled, (state, action: PayloadAction<IGetReferalsResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.items = action.payload.referals.sort((a, b) => b.exp - a.exp);
            state.milestones = action.payload.milestones;
        })
        .addCase(getReferals.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Unable to get referals list';
        });
};

export default getReferalsHandler;